/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:01:08
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { mapGetters } from 'vuex';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'LoginErrorMessages',

  computed: {
    ...mapGetters(['loginErrorReason']),
  },
};



// WEBPACK FOOTER //
// ./src/components/Login/LoginErrorMessages/component.js